import { motion } from "framer-motion";
import { BlueprintGrid, CrossMarker } from "../components/BlueprintGrid";
import { lineMask, EASE } from "../lib/motion";
import { HIW_DISCLAIMER } from "../lib/howitworks";
import { LOCATION_COORDINATE_META } from "../lib/site";

const LINES = ["FROM PLANS", "TO DECISIONS."];

const HowHero = () => (
    <section
        data-testid="hiw-hero"
        className="relative overflow-hidden bg-ink"
    >
        <BlueprintGrid />
        <CrossMarker className="absolute right-10 top-28 hidden text-white/25 md:block" />

        <div className="relative z-10 mx-auto w-full max-w-[1600px] px-6 pb-16 pt-[128px] md:px-10 lg:px-16 lg:pt-[176px]">
            <motion.p
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
                className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist"
            >
                <span className="h-1.5 w-1.5 bg-accent" />
                HOW IT WORKS — FIVE STEPS
            </motion.p>

            <h1
                data-testid="hiw-headline"
                className="mt-8 font-display text-[clamp(2.4rem,7.5vw,7rem)] font-bold leading-[1.02] text-white"
            >
                {LINES.map((line, i) => (
                    <span
                        key={line}
                        className="-mb-[0.08em] block overflow-hidden pb-[0.08em]"
                    >
                        <motion.span
                            className="block"
                            variants={lineMask}
                            initial="hidden"
                            animate="show"
                            custom={i}
                        >
                            {i === 1 ? (
                                <>
                                    TO DECISIONS
                                    <span className="text-accent">.</span>
                                </>
                            ) : (
                                line
                            )}
                        </motion.span>
                    </span>
                ))}
            </h1>

            <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, ease: EASE, delay: 0.7 }}
                className="mt-8 max-w-2xl text-[16px] leading-relaxed text-mist md:text-lg"
            >
                BuildEase is designed to be understandable to a homeowner with
                no construction background. Here is the journey, step by step.
            </motion.p>

            <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 0.9 }}
                className="mt-6 max-w-2xl border-l-2 border-accent/60 pl-5 font-mono text-[13px] leading-relaxed tracking-[0.14em] text-mist/80"
            >
                {HIW_DISCLAIMER}
            </motion.p>
        </div>

        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.1 }}
            className="relative z-10 border-t border-white/10"
            data-testid="hiw-metadata-bar"
        >
            <div className="mx-auto flex max-w-[1600px] items-center justify-between gap-6 px-6 py-4 font-mono text-[13px] tracking-[0.24em] text-mist/80 md:px-10 lg:px-16">
                <span className="hidden sm:block">BUILD INTELLIGENCE</span>
                <span>HOW IT WORKS</span>
                <span>SOUTH AFRICA</span>
                <span className="hidden md:block">{LOCATION_COORDINATE_META}</span>
            </div>
        </motion.div>
    </section>
);

export default HowHero;
